// Leaf - Event - select_flavour - Start

(function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var REFILLS_HANDLE = 'restore-refillable-gel-toothpaste';
  
    function getRefillsStep(input) {
      return input.closest('[data-bb-step][data-bb-product-handle="' + REFILLS_HANDLE + '"]');
    }
  
    function getStepProductData(step) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      var productId = null;
      if (configEl) {
        try {
          var config = JSON.parse(configEl.textContent);
          if (config.variants && config.variants.length > 0) {
            for (var j = 0; j < config.variants.length; j++) {
              if (config.variants[j].featured_image && config.variants[j].featured_image.product_id) {
                productId = config.variants[j].featured_image.product_id;
                break;
              }
            }
          }
        } catch (e) {}
      }
      return {
        product_id: productId,
        product_name: (step && step.dataset.bbStepTitle) || null
      };
    }
  
    function normalizeFlavourName(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isFlavourInput(input) {
      if (input.closest('.option_values.modern-flavour')) return true;
      if (input.closest('.modern-flavour__featured-wrap')) return true;
      return false;
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!input.dataset.optionValue) return;
        if (!isFlavourInput(input)) return;
  
        var step = getRefillsStep(input);
        if (!step) return;
  
        var productData = getStepProductData(step);
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_flavour',
          flavour_name: normalizeFlavourName(input.dataset.optionValue),
          product_id: productData.product_id,
          product_name: productData.product_name
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_flavour - End
  
  // Leaf - Event - select_plan - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var REFILLS_HANDLE = 'restore-refillable-gel-toothpaste';
  
    function getRefillsStep(input) {
      return input.closest('[data-bb-step][data-bb-product-handle="' + REFILLS_HANDLE + '"]');
    }
  
    function getProductIdFromStep(step) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      if (!configEl) return null;
      try {
        var config = JSON.parse(configEl.textContent);
        if (config.variants && config.variants.length > 0) {
          for (var j = 0; j < config.variants.length; j++) {
            if (config.variants[j].featured_image && config.variants[j].featured_image.product_id) {
              return config.variants[j].featured_image.product_id;
            }
          }
        }
      } catch (e) {}
      return null;
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isOneTimeInput(input) {
      if (input.id && input.id.endsWith('-buy_once')) return true;
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      if (input.id && /-sub$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function getPlanFrequency(input) {
      var wrapper = input.closest('.subscription-options-block');
      if (!wrapper) return 'na';
  
      var interval = wrapper.dataset.mainDeliveryInterval;
      if (interval && interval.trim()) return normalizeValue(interval);
  
      var recurrence = wrapper.dataset.recurrenceLabel;
      if (recurrence && recurrence.trim()) return normalizeValue(recurrence);
  
      return 'na';
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!input.closest('.subscription-options-block')) return;
  
        // Scope to Canopy refills step only — SURI brush also has a subscription block
        var step = getRefillsStep(input);
        if (!step) return;
  
        var planType, planFrequency;
  
        if (isOneTimeInput(input)) {
          planType = 'one_time';
          planFrequency = 'na';
        } else if (isSubscribeInput(input)) {
          planType = 'subscribe';
          planFrequency = getPlanFrequency(input);
        } else {
          return;
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_plan',
          plan_type: planType,
          plan_frequency: planFrequency,
          product_id: getProductIdFromStep(step)
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_plan - End
  
  // Leaf - Event - select_variant - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var BOTTLE_HANDLE = 'restore-refillable-gel-toothpaste-bottle';
  
    function getBottleStep(input) {
      return input.closest('[data-bb-step][data-bb-product-handle="' + BOTTLE_HANDLE + '"]');
    }
  
    function getProductIdFromStep(step) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      if (!configEl) return null;
      try {
        var config = JSON.parse(configEl.textContent);
        if (config.variants && config.variants.length > 0) {
          for (var j = 0; j < config.variants.length; j++) {
            if (config.variants[j].featured_image && config.variants[j].featured_image.product_id) {
              return config.variants[j].featured_image.product_id;
            }
          }
        }
      } catch (e) {}
      return null;
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isBottleColourInput(input) {
      if (!input.dataset.optionValue) return false;
      if (input.dataset.frontendHidden === 'true') return false;
      var group = input.closest('.product_variant_option');
      if (!group) return false;
      var optionName = (group.dataset.optionName || '').toLowerCase();
      if (!(optionName === 'colour' || optionName === 'color' ||
            optionName.includes('colour') || optionName.includes('color'))) return false;
      // Scope to Canopy bottle step only — SURI brush also has a Colour option
      return !!getBottleStep(input);
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!isBottleColourInput(input)) return;
  
        var step = getBottleStep(input);
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_variant',
          variant_type: 'bottle_colour',
          variant_value: normalizeValue(input.dataset.optionValue),
          product_id: getProductIdFromStep(step),
          product_name: 'Restore bottle'
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_variant - End
  
  // Leaf - Event - select_variant - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var SURI_HANDLE = 'suri-2-sonic-toothbrush-uv-c-led-case';
  
    function getSuriStep(input) {
      return input.closest('[data-bb-step][data-bb-product-handle="' + SURI_HANDLE + '"]');
    }
  
    function getProductIdFromStep(step) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      if (!configEl) return null;
      try {
        var config = JSON.parse(configEl.textContent);
        if (config.variants && config.variants.length > 0) {
          for (var j = 0; j < config.variants.length; j++) {
            if (config.variants[j].featured_image && config.variants[j].featured_image.product_id) {
              return config.variants[j].featured_image.product_id;
            }
          }
        }
      } catch (e) {}
      return null;
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isDeviceColourInput(input) {
      if (!input.dataset.optionValue) return false;
      if (input.dataset.frontendHidden === 'true') return false;
      var group = input.closest('.product_variant_option');
      if (!group) return false;
      var optionName = (group.dataset.optionName || '').toLowerCase();
      if (!(optionName === 'colour' || optionName === 'color' ||
            optionName.includes('colour') || optionName.includes('color'))) return false;
      // Scope to SURI brush step only — Canopy bottle also has a Colour option
      return !!getSuriStep(input);
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!isDeviceColourInput(input)) return;
  
        var step = getSuriStep(input);
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_variant',
          variant_type: 'device_colour',
          variant_value: normalizeValue(input.dataset.optionValue),
          product_id: getProductIdFromStep(step),
          product_name: 'SURI 2.0'
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_variant - End
  
  // Leaf - Event - select_case - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var SURI_HANDLE = 'suri-2-sonic-toothbrush-uv-c-led-case';
  
    function getSuriStep(input) {
      return input.closest('[data-bb-step][data-bb-product-handle="' + SURI_HANDLE + '"]');
    }
  
    function getProductIdFromStep(step) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      if (!configEl) return null;
      try {
        var config = JSON.parse(configEl.textContent);
        if (config.variants && config.variants.length > 0) {
          for (var j = 0; j < config.variants.length; j++) {
            if (config.variants[j].featured_image && config.variants[j].featured_image.product_id) {
              return config.variants[j].featured_image.product_id;
            }
          }
        }
      } catch (e) {}
      return null;
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isCaseInput(input) {
      // data-bundle-option is unique to case_cards inputs
      if (!('bundleOption' in input.dataset)) return false;
      if (!input.closest('.option_values.legacy-tiles.bundle.case-cards')) return false;
      return !!getSuriStep(input);
    }
  
    function getPrice(input) {
      var raw = input.dataset.price;
      if (!raw) return null;
      var pence = parseInt(raw, 10);
      if (isNaN(pence)) return null;
      return pence / 100;
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!isCaseInput(input)) return;
  
        var step = getSuriStep(input);
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_case',
          case_option: normalizeValue(input.dataset.optionValue),
          price: getPrice(input),
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_case - End
  
  // Leaf - Event - select_heads - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var SURI_HANDLE = 'suri-2-sonic-toothbrush-uv-c-led-case';
  
    function getSuriStep(input) {
      return input.closest('[data-bb-step][data-bb-product-handle="' + SURI_HANDLE + '"]');
    }
  
    function isOneTimeInput(input) {
      if (input.id && input.id.endsWith('-buy_once')) return true;
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      if (input.id && /-sub(-\d+)?$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function getQuantity(input, wrapper) {
      if (isSubscribeInput(input)) {
        // Prefer data-pack-quantity (plan's pack size, e.g. 2 for "2 extra brush heads")
        // over data-plan-quantity (cart quantity, which is 1 for fixed-price plans)
        var packQty = parseInt(input.dataset.packQuantity, 10);
        if (!isNaN(packQty) && packQty > 0) return packQty;
        var planQty = parseInt(input.dataset.planQuantity, 10);
        if (!isNaN(planQty) && planQty > 0) return planQty;
        return 1;
      }
      // No subscription: read the live buy-once quantity stepper value
      var qtyEl = wrapper && wrapper.querySelector('[data-buy-once-qty-value]');
      if (qtyEl) {
        var qty = parseInt(qtyEl.textContent, 10);
        if (!isNaN(qty) && qty > 0) return qty;
      }
      return 1;
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
  
        var wrapper = input.closest('.subscription-options-block');
        if (!wrapper) return;
  
        // Scope to SURI heads subscription only — Canopy refills also has a subscription block
        var step = getSuriStep(input);
        if (!step) return;
  
        var headsPlan;
  
        if (isOneTimeInput(input)) {
          headsPlan = 'no_subscription';
        } else if (isSubscribeInput(input)) {
          headsPlan = 'subscribe';
        } else {
          return;
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_heads',
          heads_plan: headsPlan,
          quantity: getQuantity(input, wrapper)
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_heads - End
  
  // Leaf - Event - select_accessory - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    function normalizeHandle(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/[-\s]+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function normalizeColour(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function getAccessoryColour(container) {
      var valueEl = container.querySelector('[data-bb-accessory-dropdown-value]');
      if (valueEl && valueEl.textContent.trim()) {
        return normalizeColour(valueEl.textContent.trim());
      }
      var select = container.querySelector('select[data-bb-accessory-variant-select]');
      if (select && select.options[select.selectedIndex]) {
        return normalizeColour(select.options[select.selectedIndex].text);
      }
      return null;
    }
  
    function init() {
      // Accessory add / remove
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'checkbox') return;
        if (!('bbAccessoryInput' in input.dataset)) return;
  
        var container = input.closest('.bundle-builder__accessory');
        if (!container) return;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_accessory',
          accessory_name: normalizeHandle(input.dataset.bbProductHandle || ''),
          accessory_colour: getAccessoryColour(container),
          selected: input.checked
        });
      });
  
      // Accessory colour selection (custom dropdown option buttons)
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bb-accessory-dropdown-option]');
        if (!btn) return;
  
        var container = btn.closest('.bundle-builder__accessory');
        if (!container) return;
  
        var checkboxInput = container.querySelector('input[data-bb-accessory-input]');
        if (!checkboxInput) return;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_accessory',
          accessory_name: normalizeHandle(checkboxInput.dataset.bbProductHandle || ''),
          accessory_colour: normalizeColour(btn.textContent.trim()),
          selected: checkboxInput.checked
        });
      });
  
      // Accessory colour selection (native select element)
      document.addEventListener('change', function (e) {
        var sel = e.target;
        if (!sel || sel.tagName !== 'SELECT') return;
        if (!('bbAccessoryVariantSelect' in sel.dataset)) return;
  
        var container = sel.closest('.bundle-builder__accessory');
        if (!container) return;
  
        var checkboxInput = container.querySelector('input[data-bb-accessory-input]');
        if (!checkboxInput) return;
  
        var selectedOption = sel.options[sel.selectedIndex];
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_accessory',
          accessory_name: normalizeHandle(checkboxInput.dataset.bbProductHandle || ''),
          accessory_colour: selectedOption ? normalizeColour(selectedOption.text) : null,
          selected: checkboxInput.checked
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_accessory - End
  
  // Leaf - Event - add_to_cart_bundle_builder - Start
  
  (function () {
    if (window.location.pathname !== '/pages/build-your-routine') return;
  
    var REFILLS_HANDLE = 'restore-refillable-gel-toothpaste';
    var SURI_HANDLE = 'suri-2-sonic-toothbrush-uv-c-led-case';
    var BOTTLE_HANDLE = 'restore-refillable-gel-toothpaste-bottle';
    var CURRENCY = 'GBP';
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function getVariantTitle(step, variantId) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      if (!configEl) return null;
      try {
        var config = JSON.parse(configEl.textContent);
        var variants = config.variants || [];
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            return variants[i].title || null;
          }
        }
      } catch (e) {}
      return null;
    }
  
    function getAccessoryVariant(input) {
      var container = input.closest('.bundle-builder__accessory');
      if (!container) return null;
      var valueEl = container.querySelector('[data-bb-accessory-dropdown-value]');
      if (valueEl && valueEl.textContent.trim()) return valueEl.textContent.trim();
      var sel = container.querySelector('select[data-bb-accessory-variant-select]');
      if (sel && sel.options[sel.selectedIndex]) return sel.options[sel.selectedIndex].text;
      return null;
    }
  
    function getVariantSku(step, variantId) {
      var configEl = step && step.querySelector('script[data-variant-options-config]');
      if (configEl) {
        try {
          var config = JSON.parse(configEl.textContent);
          var variants = config.variants || [];
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(variantId) && variants[i].sku) {
              return variants[i].sku;
            }
          }
        } catch (e) {}
      }
      return variantId;
    }
  
    function isOneTimeInput(input) {
      if (input.id && input.id.endsWith('-buy_once')) return true;
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      if (input.id && /-sub$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function normalizeHandle(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/[-\s]+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
    }
  
    function getDeviceColour() {
      var suriStep = document.querySelector('[data-bb-step][data-bb-product-handle="' + SURI_HANDLE + '"]');
      if (!suriStep) return null;
      var input = suriStep.querySelector('.product_variant_option[data-option-name*="olour"] input[type="radio"]:checked');
      return (input && input.dataset.optionValue) ? normalizeValue(input.dataset.optionValue) : null;
    }
  
    function getCaseOption() {
      var suriStep = document.querySelector('[data-bb-step][data-bb-product-handle="' + SURI_HANDLE + '"]');
      if (!suriStep) return null;
      var input = suriStep.querySelector('.option_values.legacy-tiles.bundle.case-cards input[type="radio"]:checked');
      return (input && input.dataset.optionValue) ? normalizeValue(input.dataset.optionValue) : null;
    }
  
    function getHeadsPlan() {
      var suriStep = document.querySelector('[data-bb-step][data-bb-product-handle="' + SURI_HANDLE + '"]');
      if (!suriStep) return null;
      var subBlock = suriStep.querySelector('.subscription-options-block');
      if (!subBlock) return null;
      var checkedInput = subBlock.querySelector('input[type="radio"]:checked');
      if (!checkedInput) return null;
      if (checkedInput.classList.contains('no-subscription-input')) return 'no_subscription';
      if (checkedInput.dataset.sellingPlan) return 'subscribe';
      return null;
    }
  
    function getBottleColour() {
      var bottleStep = document.querySelector('[data-bb-step][data-bb-product-handle="' + BOTTLE_HANDLE + '"]');
      if (!bottleStep) return null;
      var input = bottleStep.querySelector('.product_variant_option[data-option-name*="olour"] input[type="radio"]:checked');
      return (input && input.dataset.optionValue) ? normalizeValue(input.dataset.optionValue) : null;
    }
  
    function getAccessory() {
      var accessoryInput = document.querySelector('input[data-bb-accessory-input]:checked');
      if (!accessoryInput) return 'na';
      return normalizeHandle(accessoryInput.dataset.bbProductHandle || '') || 'na';
    }
  
    function getFlavourName() {
      var refillsStep = document.querySelector('[data-bb-step][data-bb-product-handle="' + REFILLS_HANDLE + '"]');
      if (!refillsStep) return null;
      var input = refillsStep.querySelector('.option_values.modern-flavour input[type="radio"]:checked')
        || refillsStep.querySelector('.modern-flavour__featured-wrap input[type="radio"]:checked');
      return (input && input.dataset.optionValue) ? normalizeValue(input.dataset.optionValue) : null;
    }
  
    function getPlanType() {
      var refillsStep = document.querySelector('[data-bb-step][data-bb-product-handle="' + REFILLS_HANDLE + '"]');
      if (!refillsStep) return null;
      var subBlock = refillsStep.querySelector('.subscription-options-block');
      if (!subBlock) return null;
      var checkedInput = subBlock.querySelector('input[type="radio"]:checked');
      if (!checkedInput) return null;
      if (isOneTimeInput(checkedInput)) return 'one_time';
      if (isSubscribeInput(checkedInput)) return 'subscribe';
      return null;
    }
  
    function buildGA4Items() {
      var items = [];
      var totalValue = 0;
      var selectedInputs = document.querySelectorAll('input[data-product-selection]:checked');
  
      for (var i = 0; i < selectedInputs.length; i++) {
        var input = selectedInputs[i];
        if (input.dataset.available === 'false') continue;
        if (input.hasAttribute('data-options-unselected')) continue;
        if (input.classList.contains('no-subscription-input')) continue;
  
        var variantId = input.value;
        var step = input.closest('[data-bb-step]');
        var priceRaw = parseInt(input.dataset.price || '0', 10);
        var quantity = parseInt(input.dataset.quantity || '1', 10);
        var price = isNaN(priceRaw) ? 0 : priceRaw / 100;
        var qty = isNaN(quantity) ? 1 : quantity;
  
        items.push({
          item_id: getVariantSku(step, variantId),
          item_name: input.dataset.bbLineTitle || null,
          item_variant: ('bbAccessoryInput' in input.dataset) ? getAccessoryVariant(input) : getVariantTitle(step, variantId),
          price: price,
          quantity: qty
        });
  
        totalValue += price * qty;
      }
  
      return { items: items, value: Math.round(totalValue * 100) / 100 };
    }
  
    function init() {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bb-atc]');
        if (!btn) return;
        if (btn.disabled) return;
  
        var result = buildGA4Items();
  
        if (window.Shopify && window.Shopify.analytics) {
          window.Shopify.analytics.publish('leaf_prevent_atc', {});
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart_bundle_builder',
          ecommerce:{
            currency: CURRENCY,
            value: result.value,
            items: result.items
          },
          device_colour: getDeviceColour(),
          case_option: getCaseOption(),
          heads_plan: getHeadsPlan(),
          bottle_colour: getBottleColour(),
          accessory: getAccessory(),
          flavour_name: getFlavourName(),
          plan_type: getPlanType()
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - add_to_cart_bundle_builder - End
  